import { isObject, isNullOrUndefined, isNullOrEmptyString } from "../utils";

export function recordStringValue(record, dataIndex) {
  if (isObject(record[dataIndex])) {
    let recordValue = "";
    for (let key in record[dataIndex]) {
      recordValue = `${recordValue} ${
        isNullOrUndefined(record[dataIndex][key]) ? "" : record[dataIndex][key]
      }`;
    }
    if (!isNullOrEmptyString(recordValue)) {
      recordValue.trim();
    }
    return isNullOrUndefined(recordValue) ? "" : recordValue;
  } else {
    return isNullOrUndefined(record[dataIndex]) ? "" : record[dataIndex].toString();
  }
}
